// notification.ts — Notification and NotificationType

// Social notification types (actor-driven).
export type SocialNotificationType =
  | 'like'
  | 'reply'
  | 'follow'
  | 'follow_request'
  | 'follow_accepted'
  | 'cherish'
  | 'spread'
  | 'quote'
  | 'mention'
  | 'post'
  | 'dm'
  // Feedback-tracker watcher notification (1.20.70) — fires on a status
  // change or a public_update change for an item the viewer follows.
  | 'feedback';

// Council notification sub-kinds.
export type CouncilNotificationKind = 'under-review' | 'cleared' | 'appeal' | 'login-alert';

// All notification types (union of social + council).
export type NotificationType = SocialNotificationType | 'council';

// Notification actor (the person who triggered a social notification).
export interface NotificationActor {
  name: string;
  handle: string;
  av: string;
  verified: boolean;
}

// A single notification item.
// Social notifications carry `actor`, `postId`, and optional `snippet`.
// Council notifications carry `kind`, `team`, `body`; `actor` is absent.
export interface Notification {
  id: string;
  type: NotificationType;
  time: string;
  read: boolean;
  // Social-only fields
  actor?: NotificationActor;
  postId?: string | null;
  /** Feedback-tracker item id ("fb-42") this notification links to. */
  feedbackItemId?: string | null;
  snippet?: string;
  fromFollowed?: boolean;
  // Council-only fields
  kind?: CouncilNotificationKind | 'discussion' | 'network';
  schema_version?: number;
  resource_type?: string;
  resource_id?: string;
  canonical_url?: string;
  commentId?: string | null;
  updateCount?: number;
  team?: string;
  body?: string;
}

/** Never navigate to an arbitrary URL received over REST or push. */
export function networkNotificationPath(n: Notification): string | null {
  return n.kind === 'network' &&
    n.schema_version === 1 &&
    typeof n.canonical_url === 'string' &&
    /^\/(mixes|starter-packs|collections|guides|events|collaborations|perspectives|channels|playlists|saved-searches)\/[a-zA-Z0-9_-]+$/.test(
      n.canonical_url,
    )
    ? n.canonical_url
    : null;
}
